export default "__VITE_ASSET__9eapD4$c__"